//Used by all
require("./Common Style Files/css/alk-icons.less");
require("./css/styles.less");
require("./css/marketing.less");

//Used by index.html
require("./Common Javascript Files/AngularJS/Common/common-services");
require("./Common Javascript Files/AngularJS/Common/common-filters");
require("./Common Javascript Files/AngularJS/Common/common-directives");
require("./Common Javascript Files/AngularJS/Common/geoParser");
require("./Common Javascript Files/AngularJS/alk-geocode/module");
require("./Common Javascript Files/AngularJS/alk-maps/module");
require("./Common Javascript Files/AngularJS/alk-maps/map.utilities");
require("./Common Javascript Files/AngularJS/alk-maps/map.savedInfo");
require("./Common Javascript Files/AngularJS/alk-constants/module");
require("./Common Javascript Files/AngularJS/alk-constants/regions.js");
require("./Common Javascript Files/AngularJS/alk-constants/maxDbLengths.js");
require("./Common Javascript Files/AngularJS/alk-constants/states.js");
require("./Common Javascript Files/AngularJS/alk-constants/countries.js");
require("./Common Javascript Files/AngularJS/alk-modal/module");
require("./Common Javascript Files/AngularJS/alk-import/module");
require("./Common Javascript Files/AngularJS/alk-fleetlink/index");
require("./Common Javascript Files/AngularJS/alk-translations/module");
require("./Common Javascript Files/AngularJS/alk-translations/alkLocaleService");
require("./Common Javascript Files/AngularJS/alk-translations/alkTranslationLoader");
require("./Common Javascript Files/AngularJS/alk-translations/alkLanguageSelectDirective");
require("./app/app.translate.js");
require("./Common Javascript Files/AngularJS/alk-places/module");
require("./Common Javascript Files/AngularJS/alk-places/place.cloud.service");
require("./Common Javascript Files/AngularJS/alk-single-search/module");
require("./Common Javascript Files/AngularJS/alk-forms/module");
require("./Common Javascript Files/AngularJS/alk-authentication/module");

// account component
require("./app/account/account.controller");
require("./app/account/cancelAccount.controller");
require("./app/account/forgotPassword.controller");
require("./app/account/resetPassword.controller");
require("./app/account/login.controller");
require("./app/account/signUp.controller");
require("./app/account/signUp.service");
require("./app/account/migrate.controller");
require("./app/account/migrate.service");
require("./app/account/replaceUser.controller");
require("./app/account/user.service");
require("./app/account/page.controller");
require("./app/account/terms.controller");
require("./app/account/netSuite.service");
require("./app/account/pcmtidlogin.controller");
require("./app/account/pcmtidLogin.service");
require("./app/account/pcmtidlogout.controller");
require("./app/account/pcmmodern.controller");

// alk.common component
require("./app/alk-common/conversion.service");
require("./app/alk-common/alkAccountManagement");
require("./app/alk-common/filters");
require("./Common Javascript Files/AngularJS/alk-cloud/alkCloudMenu.directive");
require("./Common Javascript Files/AngularJS/alk-route-exceptions/module");
require("./Common Javascript Files/AngularJS/alk-route-exceptions/alkRouteException.service");
require("./Common Javascript Files/AngularJS/alk-route-exceptions/alkRouteException.layer.factory");
require("./Common Javascript Files/AngularJS/alk-validation/tid-password");

// PCM common components
require("./app/pcm-common/pcmCommon");
require("./app/pcm-common/defaultDimensions.module");
require("./app/pcm-common/defaultOptions.module");
require("./app/pcm-common/filters.module");
require("./app/pcm-common/LocationItem.module");
require("./app/pcm-common/stop.service");
require("./app/pcm-common/optionsUI.module");
require("./app/pcm-common/RouteItem.module");
require("./app/components/includeReplace.directive");
require("./app/pcm-common/ArrivalTime.module");

// map component
require("./app/map/map.service"); // use this to replace maps.service.js in alk.maps
require("./app/map/site.service");
require("./app/map/alkmaps.directive");
require("./app/map/map.controller");
require("./Common Javascript Files/AngularJS/alk-maps/mapStyleMenu.directive");
require("./Common Javascript Files/AngularJS/Maps/mapsLocation");
require("./Common Javascript Files/AngularJS/alk-maps/mapFooter.directive");

// layout component
require("./app/layout/menu.controller");
require("./app/layout/supportMenu.controller");
require("./Common Javascript Files/AngularJS/alk-marketing/module");
require("./Common Javascript Files/AngularJS/alk-marketing/landing.controller");
require("./Common Javascript Files/AngularJS/alk-marketing/footer.directive");

// route component
require("./app/route/route.service");
require("./app/route/route.controller");
require("./app/route/routeOptions.controller");
require("./app/route/leastCost.controller");
require("./app/route/routingProfile.service");

// application settings component
require("./app/applicationSettings/applicationSettings.controller");
require("./app/applicationSettings/applicationSettings.service");

// report component
require("./app/report/report.controller");

// search component
require("./app/search/search.controller");
require("./app/search/search.directive");

// places component
require("./app/places/customPlaceSet.service");
require("./app/places/favoriteLocations.service");
require("./app/places/favoriteNameValidator.service");
require("./app/places/places.controller");

// routeSync component
require("./app/route-sync/route-sync-utils/routeSync.service");
require("./app/route-sync/route-sync-utils/routeSyncErrors.service");
require("./app/route-sync/route-sync-summary/routeSyncSummary.directive");
require("./app/route-sync/route-sync-panel/routeSyncPanel.directive");

// vehicle component
require("./app/vehicle/vehicle.service");
require("./app/vehicle/vehicles.controller");

// AFs component
require("./app/avoidFavors/avoidFavorsPanel.directive");
require("./app/avoidFavors/avoidFavors.layer.service");
require("./app/avoidFavors/avoidFavorsMap.directive");

require("./app/components/hover.directive");
require("./app/components/list.directive");
require("./app/components/datetimepick.directive");
require("./app/components/focus.directive");

require("./app/components/validation.directive");
require("./app/components/copyright.directive");
require("./app/components/creditCard.directive");
require("./app/components/messages.directive");
require("./app/components/formContainer.directive");
require("./app/components/classOnValue.directive");
require("./app/components/showOnKey.directive");
require("./app/components/pcmwsuiMessage.directive");


// WEBPACK FOOTER //
// ./bundleIndex.js